import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import usePostSetGlobalPayCredentials from '../../../hooks/useApi/usePostSetGlobalPayCredentials';

import UpdateGlobalPaymentsForm from './UpdateGlobalPaymentsForm';
import UpdateGlobalPaymentsReview from './UpdateGlobalPaymentsReview';
import UpdateGlobalPaymentsContext, { UpdateGlobalPaymentsCtx } from './Dialogue/UpdateGlobalPaymentsContext';
import UpdateGlobalPaymentsDialogue from './Dialogue/UpdateGlobalPaymentsDialogue';
import { UpdateGlobalPaymentsDialogueHandler, DialogueHandlerProps } from './Dialogue/types';
import { useClientData } from '../../../providers/ClientData.provider';

type FC = FunctionComponent;

const GlobalPayments: FC = () => {
  const history = useHistory();
  const [UpdateError, setUpdateError] = useState('');
  const [showUpdateErrorAlert, setShowUpdateErrorAlert] = useState(false);
  const [showUpdateSuccessAlert, setShowUpdateSuccessAlert] = useState(false);
  const [shouldUpdateGlobalPayments, setShouldUpdateGlobalPayments] = useState(false);
  const [setGlobalPaymentsCredentialsResponse, setGlobalPaymentsCredentials] = usePostSetGlobalPayCredentials({});

  const [review, setReview] = useState(false);
  const { response } = useClientData();
  const [GlobalPaymentsRequest, setGlobalPaymentsRequest] = useState<vp.SetGlobalPayCredentialsRequest>({
    GlobalPayAppID: '',
    GlobalPaySharedSecret: '',
    PortalUser: response.LoginUserName,
  });

  const UpdateGlobalPayments: UpdateGlobalPaymentsCtx = {
    showUpdateSuccessAlert,
    showUpdateErrorAlert,
    UpdateError,
  };
  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<UpdateGlobalPaymentsDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: UpdateGlobalPaymentsDialogueHandler = {
        update: {
          success: {
            default: () => {
              setShowUpdateSuccessAlert(false);
              history.push('/integrations');
            },
          },
          error: {
            default: () => {
              setShowUpdateErrorAlert(false);
              setUpdateError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
    onReview: (values: vp.SetGlobalPayCredentialsRequest) => {
      setReview(true);
      setGlobalPaymentsRequest(values);
    },
    onUpdate: (values: vp.SetGlobalPayCredentialsRequest) => {
      setShouldUpdateGlobalPayments(true);

      setGlobalPaymentsCredentials(values);
    },
    onBack: () => {
      setReview(false);
    },
  };

  useEffect(() => {
    if (shouldUpdateGlobalPayments) {
      setShouldUpdateGlobalPayments(false);

      if (setGlobalPaymentsCredentialsResponse?.Success === true) {
        setShowUpdateSuccessAlert(true);
      } else {
        setUpdateError(setGlobalPaymentsCredentialsResponse?.ErrorMessage || '');
        setShowUpdateErrorAlert(true);
      }
    }
  }, [setGlobalPaymentsCredentialsResponse]);

  return (
    <UpdateGlobalPaymentsContext.Provider value={UpdateGlobalPayments}>
      {!review && <UpdateGlobalPaymentsForm defaultValues={GlobalPaymentsRequest} onSubmit={handlers.onReview} />}
      {review && (
        <UpdateGlobalPaymentsReview
          defaultValues={GlobalPaymentsRequest}
          onSubmit={handlers.onUpdate}
          onBack={handlers.onBack}
        />
      )}
      <UpdateGlobalPaymentsDialogue handleDialogue={handlers.handleDialogue} />
    </UpdateGlobalPaymentsContext.Provider>
  );
};

export default GlobalPayments;
